import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment"
@Injectable({
  providedIn: 'root'
})
export class PaymentConfigService {

  constructor(private http : HttpClient) {}
  savecreditCard(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/payments/paymentcard",result,{headers : headers,observe:"response"});
   }
   statuscreditCard(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/payments/status",result,{headers : headers,observe:"response"});
   }
   updateCreditCard(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/payments/updatePaymentcard",result,{headers : headers,observe:"response"});
   }
   creditCardList() {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/payments/paymentcards",{headers : headers,observe:"response"});
   }
   MOTOCardList(cardId:any) {
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/payments/paymentcardlist/"+cardId,{headers : headers,observe:"response"});
   }
   JusPayLink(request:any) {
   
    return this.http.post(environment.API_URL+"/api/juspay/create-order",request,{observe:"response"});
   }

   
   creditPassthroughCardList(cartId:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/payments/AIR/supplier/passthrough/details/"+cartId,{headers : headers,observe:"response"});
   }

   paymentstatusList(cartId:any) {
   
    return this.http.post(environment.API_URL+"/api/pg/service/order/paymentstatus",cartId,{observe:"response"});
   }
   
   
  productList() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/product/products" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  cardtypeList() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/payments/paymentcardtypes" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  bankList() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/payments/banks" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  paymentMediumList(request:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/payments/paymentmedium/status" ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  getMediumActive() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/payments/paymentmedium/getactive" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  savepaymentMedium(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/payments/paymentmedium/paymentmedium",result,{headers : headers,observe:"response"});
   }
   savePaymentDeposits(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/payments/ledgerentry",result,{headers : headers,observe:"response"});
   }

   getBalance(balance:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/payments/ledgerbalance/"+balance ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  getHistoryBalance(paymedium:any,accountName:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/payments/ledgerstatement/"+paymedium+"/"+accountName ,null)  
  }
  getMBalance(balance:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/payments/ledgerbal/"+balance ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
}
